import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { environment } from "../../environments/environment";
import { AppConfigService } from "../config/app-config.service";
import { JWTRefreshTokenRequest, JWTRefreshTokenResponse, ServiceResult, tblToken } from "../_models/app-models";

const Base_URL = `${environment.reviewFormApiBaseUrl}`;
//const API_REVIEW_FORM_URL = `${Base_URL}/BenefitsPortalFormsApi/api`;
let API_REVIEW_FORM_URL = `${Base_URL}/BenefitsPortalFormsApi/api`;

@Injectable({
  providedIn: 'root'
})
export class AppFormsNavigatorService {

  //constructor(private http: HttpClient) { }

  constructor(private http: HttpClient, private appConfigService: AppConfigService) {
    API_REVIEW_FORM_URL = this.appConfigService.getConfigByKey("forms");
  }

  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json'
    })
  };

  validateToken(token): Observable<tblToken> {
    let httpOptions = {
      headers: new HttpHeaders({
        "Authorization": "Bearer " + token
      })
    };
    return this.http
      .post<ServiceResult<tblToken[]>>(API_REVIEW_FORM_URL + '/ReviewFormTokenService/ValidateToken', null, httpOptions)
      .pipe(map(r => this.extractData(r)));
  }

  refreshToken(token, refreshToken) {
    let httpOptions = {
      headers: new HttpHeaders({
        "Authorization": "Bearer " + token
      })
    };

    let request: JWTRefreshTokenRequest = {
      refreshToken: refreshToken
    };

    return this.http
      .post<ServiceResult<JWTRefreshTokenResponse>>(API_REVIEW_FORM_URL + '/ReviewFormTokenService/RefreshToken', request, httpOptions);
  }

  extractData(res: any) {
    return res.data;
  }
}
